import { render, staticRenderFns } from "./DateInput.vue?vue&type=template&id=bdc7ed4c&scoped=true&"
import script from "./DateInput.vue?vue&type=script&lang=js&"
export * from "./DateInput.vue?vue&type=script&lang=js&"
import style0 from "./DateInput.vue?vue&type=style&index=0&id=bdc7ed4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdc7ed4c",
  null
  
)

export default component.exports